var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"data-cy":_vm.dataCy},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"pdf-container"},[_c('font-awesome-icon',{staticClass:"pdf-icon",attrs:{"icon":"file-pdf"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }